<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-term"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="page-wrapper">
                        <div class="page-bg"></div>
                        <div class="page-content">
                            <TopBarDark
                                :title="title"
                                @clickBack="clickBack()">
                            </TopBarDark>
                            <div class="terms-page">
                                <div class="wrapper-terms">
                                    <div class="text-detail" v-html="termsContent"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">

                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue"
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
/**
 * @property {ProductDescriptionModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "TermModal",
    props: {
        controller: Object,
        modalId: String,
        loadingModal: Object, //loding modal from master controller
    },
    components: {
        TopBarDark,
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            termsContent: null,
            type: "",
            version: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        initialPDPA: function () {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion()
                .subscribe((data) => {
                    if (this.type == 'terms') {
                       this.version = data.terms.current_version;
                    } else {
                       this.version = data.privacy;
                    }
                    resolve(data);
                    BzbsPDPA.apiGetPDPAContent(this.type, this.version, this.localeCode)
                    .subscribe((data) => {
                        this.termsContent = data;
                        this.$bvModal.show(this.modalId);
                        resolve(data);
                    }, (err) => {
                        this.errorApi(err);
                        reject(err);
                    });
                }, (err) => {
                    this.errorApi(err);
                    reject(err);
                })
            });
        },
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            console.log('change', this.content);
        },
        clickBack: function(){
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.type = config.type;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.type == 'terms' ? this.title = this.lbl.static.terms.title_topbar
                                 : this.title = this.lbl.static.privacy.title_topbar;
            this.initialPDPA();
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/input/BaseButton.scss";
.modal-term{
    .page-wrapper {
        .page-bg {
            background-color: $white;
        }
    }
    .terms-page {
        .wrapper-terms {
            @include bg-curve();
            position: absolute;
            bottom: unset;
            padding: 20px 10px 10px;

            .text-detail {
                font-size: 1.1rem;
                line-height: 1.56;
                text-align: left;
                font-size: 18px;
                line-height: 1.56;
                margin: 9px 37px 20px 32px;
                color: $black;

                @include mini-mobile(){
                    font-size: 0.9rem;
                }
            }
        }
    }
}

</style>

<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-term{
    .modal-dialog{
        margin: 0;

        .modal-content{
            border: 0;

            .modal-body{
                padding: 0;
            }
        }
    }
}
</style>
